// src/store/slices/meterTypesSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchMeterTypesThunk = createAsyncThunk(
  "meterTypes/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/meter-types"); // ✅ your backend route
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

const meterTypesSlice = createSlice({
  name: "meterTypes",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchMeterTypesThunk.pending, (s) => {
      s.loading = true;
      s.error = null;
    });
    b.addCase(fetchMeterTypesThunk.fulfilled, (s, a) => {
      s.loading = false;
      s.list = a.payload || [];
    });
    b.addCase(fetchMeterTypesThunk.rejected, (s, a) => {
      s.loading = false;
      s.error = a.payload || "Failed";
    });
  },
});

export default meterTypesSlice.reducer;
